var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMailBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.50065 2.6665H12.5007C13.656 2.6665 14.6001 3.57081 14.6639 4.71022L14.6673 4.83317V11.1665C14.6673 12.3219 13.763 13.266 12.6236 13.3297L12.5007 13.3332H3.50065C2.3453 13.3332 1.40115 12.4289 1.33741 11.2895L1.33398 11.1665V4.83317C1.33398 3.67782 2.23829 2.73367 3.3777 2.66993L3.50065 2.6665H12.5007H3.50065ZM13.6673 6.2485L8.23352 9.10896C8.10858 9.17472 7.96274 9.18412 7.83183 9.13715L7.76778 9.10896L2.33398 6.24917V11.1665C2.33398 11.7786 2.80539 12.2806 3.40497 12.3293L3.50065 12.3332H12.5007C13.1128 12.3332 13.6148 11.8618 13.6635 11.2622L13.6673 11.1665V6.2485ZM12.5007 3.6665H3.50065C2.88854 3.6665 2.38652 4.13791 2.33785 4.73749L2.33398 4.83317V5.11917L8.00065 8.10148L13.6673 5.1185V4.83317C13.6673 4.22105 13.1959 3.71904 12.5963 3.67037L12.5007 3.6665Z",
    fill: "#1C3D61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailBlue);
export default __webpack_public_path__ + "static/media/icon-mail-blue.1bf3fc04c3aea758cae46d6ddd586164.svg";
export { ForwardRef as ReactComponent };